<template>
  <div class="yahav-is-back">
    <div class="information">
      <lottie-player :src="JSON.stringify(require('@/assets/animations/yahavIsBack.json'))" :autoplay="true" class="header-image"/>
      <div class="body">
        <div class="title">
          <slot name="information-title">{{ firstName }}, השירות זמין ללקוחות יהב ואיזה כיף לראות אותך שוב!</slot>
        </div>
        <div class="description">
          <p>
            עבר קצת זמן מאז הפעם האחרונה שהתראינו וחשוב לנו שהחזרה שלך לשירות תעבור חלק.
          </p><p>
            <b>הצוות שלנו זמין בשבילך בצ׳אט</b> לכל שאלה שצצה.
          </p>
        </div>
      </div>
      <div class="footer">
        <single-click-button title="להמשך החיבור" :action="next" :size="'small'"/>
      </div>
    </div>
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';
import Segment from '../../../../../Segment';
import SingleClickButton from '../../../../../base-components/SingleClickButton';

export default {
  async created() {
    Segment.trackUserGot('WhatsappOptInEntered');
  },
  components: {
    SingleClickButton,
  },
  name: 'BotiIntro',
  computed: {
    ...mapGetters('session', ['firstName']),
  },
  methods: {
    ...mapActions('onboardingState', ['onboardingPageSubmit']),
    next() {
      Segment.trackUserInteraction('WhatsappOptInConfirmClicked');
      this.onboardingPageSubmit();
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .yahav-is-back {
    height: 100%;

    .information {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;

      .header-image {
        margin: 65px auto 20px;
        width: 284px;
      }

      .body {
        color: $riseup_black;
        position: relative;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        padding: 26px;
        padding-bottom: 0px;
        text-align: center;

        .title {
          font-size: 24px;
          font-weight: bold;
          line-height: 32px;
          padding: 10px 0px;
          white-space: pre-line;
        }

        .description {
          padding: 16px 0px;
          font-size: 18px;
          line-height: 1.3;
          flex-grow: 1;

          p:first-child {
            margin-bottom: 20px;
          }
        }

        .bold {
          font-weight: bold;
        }

      }

      lottie-player {
        height: auto;
      }

      .footer {
        position: sticky;
        bottom: 0;
        display: flex;
        justify-content: center;
        background-color: $riseup_white;
        padding: 30px;

        .riseup-button {
          width: 100%;
          height: 75px;
        }
      }
    }
  }

</style>
